import { centsToFormattedDollars } from '@fruitful/fruitils';
import { MoneyMapCategory } from '@fruitful/types';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    LabelRegular,
    redactPrivate,
    XStack,
} from 'smoothie';

import {
    MoneyMapCategoryToColorMap,
    MoneyMapCategoryToLabelMap,
} from '../constants';

const MoneyMapCategoryToTextColorMap = {
    [MoneyMapCategory.INCOME]: '$lemonDarkest',
    [MoneyMapCategory.BILLS]: '$waterDarkest',
    [MoneyMapCategory.SPEND]: '$leafDarkest',
    [MoneyMapCategory.GOALS]: '$petalDarkest',
    [MoneyMapCategory.OTHER_ACCOUNTS]: '$gray1100',
} as const;

interface MoneyMapCategoryHeaderRedesignProps {
    category: MoneyMapCategory;
    numAccounts: number;
    totalAmountCents: number | null;
}

export const MoneyMapCategoryHeaderRedesign = ({
    category,
    numAccounts,
    totalAmountCents,
}: MoneyMapCategoryHeaderRedesignProps) => {
    const showMonthlyTotal = category !== MoneyMapCategory.OTHER_ACCOUNTS;
    const textColor = MoneyMapCategoryToTextColorMap[category];

    return (
        <XStack
            backgroundColor={MoneyMapCategoryToColorMap[category]}
            alignItems="center"
            justifyContent={showMonthlyTotal ? 'space-between' : 'flex-start'}
            padding={14}
            {...redactPrivate()}
        >
            <XStack gap={8} alignItems="baseline">
                <BodyMediumRegular color={textColor}>
                    {MoneyMapCategoryToLabelMap[category]}
                </BodyMediumRegular>
                <LabelRegular color={textColor}>
                    {`${numAccounts} account${numAccounts !== 1 ? 's' : ''}`}
                </LabelRegular>
            </XStack>
            {showMonthlyTotal && (
                <XStack alignItems="center">
                    <BodyMediumEmphasized color={textColor}>
                        {totalAmountCents != null
                            ? centsToFormattedDollars(totalAmountCents, false)
                            : '--'}
                    </BodyMediumEmphasized>
                    <BodyMediumRegular color={textColor}>/mo</BodyMediumRegular>
                </XStack>
            )}
        </XStack>
    );
};
